// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function defaultValue_refetchModifications(param) {
  
}

function defaultValue_openPendingPrioritiesTab(param) {
  
}

var defaultValue_edited_modifications = {};

var defaultValue = {
  refetchModifications: defaultValue_refetchModifications,
  openPendingPrioritiesTab: defaultValue_openPendingPrioritiesTab,
  zones: /* [] */0,
  clusters: /* [] */0,
  modified_priorities: /* [] */0,
  initial_priorities: /* [] */0,
  edited_modifications: defaultValue_edited_modifications
};

var context = React.createContext(defaultValue);

function useContext(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useContext ,
  
}
/* context Not a pure module */
